import { useMemo } from 'react'

/**
 * Konfetti bei Gewinn, Regen bei Verlust.
 *
 * WETTBANDIT-63: Der Regen bestand aus roten Strichen und sah damit aus wie
 * rotes Konfetti - also weiter nach Feier statt nach Verlust. Jetzt sind es
 * schraege, graublaue Tropfen, die deutlich schneller fallen.
 *
 * Die Positionen sind aus dem Index berechnet statt zufällig: dieselbe Bilanz
 * ergibt dasselbe Bild, auch nach einem Neuladen. Wer Animationen abgestellt
 * hat, sieht gar nichts - der Effekt ist reine Dramaturgie und trägt keine
 * Information.
 */
export function FXOverlay({ kind }: { kind: 'confetti' | 'rain' | 'none' }) {
    const reduceMotion = useMemo(
        () =>
            typeof window !== 'undefined' &&
            (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false),
        [],
    )

    if (kind === 'none' || reduceMotion) {
        return null
    }

    const pieces = Array.from({ length: 40 }, (_, index) => ({
        left: (index * 7 + ((index * index) % 13)) % 100,
        delay: (index % 10) * 0.15,
        duration: 2 + (index % 5) * 0.4,
        color: ['#ff8a1a', '#3cf07a', '#5aa8ff', '#ffd23f', '#ff3b5c'][index % 5] as string,
    }))

    return (
        <div
            aria-hidden="true"
            data-testid={`fx-${kind}`}
            className="pointer-events-none absolute inset-0 z-100 overflow-hidden"
        >
            {pieces.map((piece, index) =>
                kind === 'confetti' ? (
                    <div
                        key={index}
                        className="absolute top-0 h-3 w-2 rounded-[2px]"
                        style={{
                            left: `${piece.left}%`,
                            background: piece.color,
                            animation: `wb-fall ${piece.duration}s ${piece.delay}s linear infinite`,
                        }}
                    />
                ) : (
                    <div
                        key={index}
                        className="absolute top-0 h-6 w-[1.5px] rounded-full opacity-75"
                        style={{
                            left: `${piece.left}%`,
                            background:
                                'linear-gradient(to bottom, rgba(165,190,220,0), rgba(165,190,220,1))',
                            animation: `wb-rain ${piece.duration * 0.45}s ${piece.delay * 0.4}s linear infinite`,
                        }}
                    />
                ),
            )}
        </div>
    )
}
